/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LoginInputs */

const cs_enum_login = /** @type {(inputs: Enum_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení`)
};

const en_enum_login = /** @type {(inputs: Enum_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Enum_LoginInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_login = /** @type {((inputs?: Enum_LoginInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LoginInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_login(inputs)
	return cs_enum_login(inputs)
});